import { feeTypeMismoApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const MISMO_FEE_LIST_ACTION_TYPE = createNamedActions('feeTypeMismo', {
  GET_LIST: 'GET_LIST',
});

export const getFeeTypeMismoAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await feeTypeMismoApi.getList(params);

  return dispatch({
    type: MISMO_FEE_LIST_ACTION_TYPE.GET_LIST,
    payload: data,
  });
});
